import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_AULARIO = 'ALL_AULARIO';
export const ACTIVO_AULARIO = 'ACTIVO_AULARIO';
export const LOADING_ALL_AULARIO = 'LOADING_ALL_AULARIO';
export const PARAMS_AULARIO = 'PARAMS_AULARIO';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {},
};

export const aularioReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_AULARIO:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_AULARIO:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_AULARIO:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_AULARIO:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
